export enum TimeFilterType {
  DATE = 'date',
  TIME = 'time',
  DATETIME = 'datetime',
  YEAR = 'year'
}

export enum TimeFilterStyle {
  CALENDAR = 'calendar',
  SLIDER = 'slider'
}
